import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Warning Fill
 */

export default function WarningFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M2.00129 14.9996H14.0001C14.7434 14.9996 15.2269 14.2173 14.8945 13.5524L8.89512 1.55281C8.5266 0.81573 7.47476 0.81573 7.10624 1.55281L1.10685 13.5524C0.774423 14.2173 1.25792 14.9996 2.00129 14.9996ZM8.5093 12.459C8.5093 12.7392 8.28194 12.9665 8.00147 12.9665C7.72101 12.9665 7.49365 12.7392 7.49365 12.459C7.49365 12.1787 7.72101 11.9515 8.00147 11.9515C8.28194 11.9515 8.5093 12.1787 8.5093 12.459ZM8.50147 5.85719C8.50147 5.58105 8.27762 5.35719 8.00147 5.35719C7.72533 5.35719 7.50147 5.58105 7.50147 5.85719V9.92006C7.50147 10.1962 7.72533 10.4201 8.00147 10.4201C8.27762 10.4201 8.50147 10.1962 8.50147 9.92006V5.85719Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
